import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkText } from "uitk-react-text";
import { getRatingText } from "components/utility/Reviews";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";

const GuestRating = (props: { hotel: Hotel; className: string }) => {
  const { formatText } = useLocalization();
  const { hotel, className } = props;
  const { hotelOverallReviewRating, reviewCount } = hotel;

  if (!(hotelOverallReviewRating && reviewCount)) {
    return (
      <UitkText size={300} className={className}>
        {formatText("hotels.review.noReviews")}
      </UitkText>
    );
  }

  const numberOfReviewsLocalized = `hotels.review.${reviewCount > 1 ? "reviewCountPlural" : "reviewCountSingular"}`;

  return (
    <UitkText size={300} className={className}>
      <span className="uitk-type-heading-300">
        {formatText("hotelRecentReviews.ratingSlashNoSpace", Math.round(hotelOverallReviewRating))}
      </span>

      <span className="all-l-margin-one uitk-type-300">
        {getRatingText(hotelOverallReviewRating)} ({formatText(numberOfReviewsLocalized, reviewCount)})
      </span>
    </UitkText>
  );
};

export default GuestRating;
